import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./components/ui/Header";
import CertificateRoute from "./pages/CertificateRoute";
import Home from "./pages/Home";
import OrderProcess from "./pages/OrderProcess";
import { getUTMParameters, registerOnce, trackPageView } from "./utils/analytics";

function MainLayout() {
  const location = useLocation();

  // Page view and UTM tracking
  useEffect(() => {
    const utmParams = getUTMParameters();
    if (Object.keys(utmParams).length > 0) registerOnce(utmParams);
    const path = location.search ? `${location.pathname}${location.search}` : location.pathname;
    trackPageView(path);
  }, [location.pathname, location.search]);

  // Scroll to top when navigating to home page
  useEffect(() => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen w-full bg-collectors-bg text-black selection:bg-black selection:text-white font-sans overflow-x-hidden flex flex-col">
      <Header />
      <main className="flex-grow flex flex-col items-center md:justify-center p-6 relative w-full max-w-[1600px] mx-auto mt-[100px] md:mt-0">
        <Outlet />
      </main>
    </div>
  );
}

const routes = [
  {
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/orders/:orderId",
        element: <OrderProcess />,
        children: [
          {
            path: "certificate",
            element: <CertificateRoute />,
          },
        ],
      },
    ],
  },
];

export default routes;
